import axiosClient from './utils/axiosClient';

export const CODING_GAME_API_URI = 'coding-games';
export class CodingGameApi {

    static testCompile(code: string) {
        return axiosClient.post(`${CODING_GAME_API_URI}/compile`, code);
    }

    static runTests(codingGame: any) {
        return axiosClient.post(`${CODING_GAME_API_URI}/run-tests`, codingGame);
    }

    static trySolution(codingGame: any) {
        return axiosClient.post(`${CODING_GAME_API_URI}/try-solution`, codingGame);
    }
}